import { IkasVariantValue } from "./variant-value";

export type IkasVariantType = {
  id: string;
  name: string;
  selectionType: IkasVariantSelectionType;
  values: IkasVariantValue[];
  translations?: IkasVariantTypeTranslation[] | null;
};

export enum IkasVariantSelectionType {
  CHOICE = "CHOICE",
  COLOR = "COLOR",
}

export type IkasVariantTypeTranslation = {
  locale: string;
  name: string | null;
  values: IkasVariantValueTranslation[] | null;
};

export type IkasVariantValueTranslation = {
  id: string;
  name: string | null;
};
